module.exports = "/_next/static/images/HeroIllustration-fbfb55f230ef77782b7bd38fbf3c42f7.svg";